import _typeof from "@babel/runtime/helpers/typeof";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
import Abstract from '../abstract';
import { defineComponent, resolveComponent, openBlock, createElementBlock, normalizeClass, createElementVNode, toDisplayString, createVNode, withCtx, Fragment, renderList, createBlock, createTextVNode } from 'vue';
import QuestionCircleOutlined from '@ant-design/icons-vue/QuestionCircleOutlined';
var _sfc_main = defineComponent({
  name: 'ApiTable',
  extends: Abstract,
  components: {
    QuestionCircleOutlined: QuestionCircleOutlined
  },
  props: {
    title: {
      type: String,
      required: false
    },
    dataSource: Array
  },
  data: function data() {
    return {
      className: 'api-table'
    };
  },
  created: function created() {}
});
var _export_sfc = function _export_sfc(sfc, props) {
  var target = sfc.__vccOpts || sfc;
  var _iterator = _createForOfIteratorHelper(props),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        val = _step$value[1];
      target[key] = val;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return target;
};
var _hoisted_1 = {
  class: "title"
};
var _hoisted_2 = ["innerHTML"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_table_column = resolveComponent("a-table-column");
  var _component_a_typography_link = resolveComponent("a-typography-link");
  var _component_a_typography_text = resolveComponent("a-typography-text");
  var _component_QuestionCircleOutlined = resolveComponent("QuestionCircleOutlined");
  var _component_a_tooltip = resolveComponent("a-tooltip");
  var _component_a_table = resolveComponent("a-table");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(_ctx.prefixCls)
  }, [createElementVNode("h2", _hoisted_1, toDisplayString(_ctx.title ? _ctx.title : "Api"), 1
  /* TEXT */), createVNode(_component_a_table, {
    "row-key": "param",
    "data-source": _ctx.dataSource,
    pagination: false
  }, {
    default: withCtx(function () {
      return [createVNode(_component_a_table_column, {
        "data-index": "param",
        title: "\u53C2\u6570"
      }), createVNode(_component_a_table_column, {
        "data-index": "describe",
        title: "\u8BF4\u660E"
      }, {
        customRender: withCtx(function (_ref) {
          var text = _ref.text;
          return [createElementVNode("div", {
            innerHTML: text
          }, null, 8, _hoisted_2)];
        }),
        _: 1
        /* STABLE */
      }), createVNode(_component_a_table_column, {
        "data-index": "types",
        title: "\u7C7B\u578B"
      }, {
        customRender: withCtx(function (_ref2) {
          var text = _ref2.text;
          return [(openBlock(true), createElementBlock(Fragment, null, renderList(text, function (type, i) {
            return openBlock(), createElementBlock(Fragment, {
              key: i
            }, [_typeof(type) === "object" && type.anchor ? (openBlock(), createBlock(_component_a_typography_link, {
              key: 0,
              class: "type-item",
              href: type.anchor
            }, {
              default: withCtx(function () {
                return [createTextVNode(toDisplayString(type.name), 1
                /* TEXT */)];
              }),

              _: 2
              /* DYNAMIC */
            }, 1032, ["href"])) : (openBlock(), createBlock(_component_a_typography_text, {
              key: 1,
              class: "type-item",
              type: "danger"
            }, {
              default: withCtx(function () {
                return [createTextVNode(toDisplayString(typeof type === "string" ? type : type.name), 1
                /* TEXT */)];
              }),

              _: 2
              /* DYNAMIC */
            }, 1024
            /* DYNAMIC_SLOTS */))], 64
            /* STABLE_FRAGMENT */);
          }), 128
          /* KEYED_FRAGMENT */))];
        }),

        _: 1
        /* STABLE */
      }), createVNode(_component_a_table_column, {
        "data-index": "values",
        title: "\u53EF\u9009\u503C"
      }, {
        customRender: withCtx(function (_ref3) {
          var text = _ref3.text;
          return [!text || text.length == 0 ? (openBlock(), createElementBlock(Fragment, {
            key: 0
          }, [createTextVNode(" \u2014 ")], 64
          /* STABLE_FRAGMENT */)) : (openBlock(true), createElementBlock(Fragment, {
            key: 1
          }, renderList(text, function (item, i) {
            return openBlock(), createBlock(_component_a_typography_text, {
              class: "value-item",
              key: i
            }, {
              default: withCtx(function () {
                return [createTextVNode(toDisplayString(item), 1
                /* TEXT */)];
              }),

              _: 2
              /* DYNAMIC */
            }, 1024
            /* DYNAMIC_SLOTS */);
          }), 128
          /* KEYED_FRAGMENT */))];
        }),

        _: 1
        /* STABLE */
      }), createVNode(_component_a_table_column, {
        "data-index": "default",
        title: "\u9ED8\u8BA4\u503C"
      }, {
        customRender: withCtx(function (_ref4) {
          var text = _ref4.text;
          return [createTextVNode(toDisplayString(text !== void 0 && text !== null ? text : "\u2014"), 1
          /* TEXT */)];
        }),

        _: 1
        /* STABLE */
      }), createVNode(_component_a_table_column, {
        "data-index": "version"
      }, {
        title: withCtx(function () {
          return [createVNode(_component_a_tooltip, {
            title: "\u4ECE x \u7248\u672C\u5F00\u59CB\u652F\u6301\u6B64api\uFF0C\u65E0\u503C\u8868\u660E\u6240\u6709\u7248\u672C\u5747\u652F\u6301"
          }, {
            default: withCtx(function () {
              return [createTextVNode(" \u7248\u672C"), createVNode(_component_QuestionCircleOutlined)];
            }),
            _: 1
            /* STABLE */
          })];
        }),

        customRender: withCtx(function (_ref5) {
          var text = _ref5.text;
          return [createTextVNode(toDisplayString(text !== void 0 && text !== null ? text : "\u2014"), 1
          /* TEXT */)];
        }),

        _: 1
        /* STABLE */
      })];
    }),

    _: 1
    /* STABLE */
  }, 8, ["data-source"])], 2
  /* CLASS */);
}

var ApiTable = /* @__PURE__ */_export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/chenghongxing/VsCodeProjects/stepin/components/api-table/ApiTable.js"]]);
export { ApiTable as default };